
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10 1a9 9 0 00-9 9v24.837a9 9 0 009 9h24.837a9 9 0 009-9V10a9 9 0 00-9-9H10z","stroke":"#504F4F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M25.2 13c1.12 0 2.03.91 2.03 2.03 0 1.12-.91 2.03-2.03 2.03h0-6.967v2.264H29.02c.2 0 .364.164.364.365h0v2.68h1.719v-1.033c0-.17.12-.32.288-.355h0l4.216-.9a.357.357 0 01.305.073h0a.365.365 0 01.135.283h0v9.452a.366.366 0 01-.441.354h0l-4.216-.898a.362.362 0 01-.289-.355h0v-1.543h-1.719v3.189c0 .2-.163.364-.364.364h0-17.68a.365.365 0 01-.364-.364h0v-7.03h-.979A1.998 1.998 0 018 21.609h0v-4.947c0-1.101.895-1.996 1.996-1.996h2.271v-.485c0-.652.53-1.181 1.18-1.181h0zm3.456 7.053H11.705v10.219h16.95v-7.54l.001-2.68zm6.663.834l-3.487.744v7.065l3.487.743v-8.552zM20.18 23.54c.2 0 .365.164.365.364h0v2.856c0 .2-.164.364-.365.364h0-5.44a.365.365 0 01-.363-.364h0v-2.856c0-.2.163-.364.364-.364h0zm4.963.307c.855 0 1.55.696 1.55 1.551s-.695 1.551-1.55 1.551c-.855 0-1.55-.696-1.55-1.55 0-.856.695-1.552 1.55-1.552zm5.961-.752h-1.718v3.624h1.718v-3.624zm-11.288 1.174h-4.711v2.127h4.711v-2.127zm5.327.305a.824.824 0 00-.822.823c0 .452.368.822.822.822a.824.824 0 00.822-.822.824.824 0 00-.822-.823zm-12.874-9.18h-2.27a1.27 1.27 0 00-1.268 1.268h0v4.947c0 .7.569 1.268 1.268 1.268h.978V19.69c0-.2.164-.365.365-.365h4.056v-2.263H13.45c-.651 0-1.18-.53-1.18-1.18h0v-.486zm5.236 1.667h-1.38v2.263h1.38v-2.263zm7.696-3.332H13.45a.453.453 0 00-.453.452h0l-.002 1.7c0 .25.204.451.453.451H25.2a1.302 1.302 0 000-2.603h0z","stroke":"#BF9C5F","stroke-width":".3","fill":"#BF9C5F","fill-rule":"nonzero"}})])])
          )
        }
      }
    